import { Box, Flex, Image } from '@chakra-ui/react';

interface LogoProps {
  logo: Blob;
}

export const Logo = ({ logo }: LogoProps) => {
  return (
    <Box w='full' p={2} borderRadius='base' h='100%' bg='gray.100'>
      <Flex justify='center' align='center' h='100%'>
        <Image src={URL.createObjectURL(logo)} maxH='72px' role='presentation' alt='' />
      </Flex>
    </Box>
  );
};
